import React, { useEffect, useState } from 'react'
import { Form, Input, Select } from 'antd'
import { connect } from 'react-redux'
import {
    type PartneshipBussinessAddress,
    type PartneshipBussinessStateProps,
} from '../../../../../../Types/Client/RegisteredClients/Partnership'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'

const BussinessAddressForm = (
    props: PartneshipBussinessAddress
): React.ReactElement => {
    const { countryList, form } = props
    const [selectedCountry, setSelectedCountry] =
        useState<string>('UNITED KINGDOM')
    const handleCountryChange = (value: string): void => {
        setSelectedCountry(value)
        props.onDateChange(value)
    }
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                busaddress1: address.line_1,
                busaddress2: address.line_2,
                bustown: address.post_town,
                buscountry: countryData?.label ?? '',
                buspostcode: address.postcode,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])

    return (
        <>
            <Form.Item
                label="Address 1"
                name="busaddress1"
                rules={[
                    {
                        required: true,
                        message: 'Please Input Your Address 1',
                    },
                ]}
            >
                <Input allowClear maxLength={200} />
            </Form.Item>
            <Form.Item label="Address 2" name="busaddress2">
                <Input allowClear maxLength={200} />
            </Form.Item>
            <Form.Item
                label="Town"
                name="bustown"
                rules={[
                    {
                        required: true,
                        message: 'Please Input Your Town',
                    },
                ]}
            >
                <Input allowClear maxLength={50} />
            </Form.Item>
            <Form.Item
                label="Country"
                name="buscountry"
                initialValue="UNITED KINGDOM"
                rules={[
                    {
                        required: true,
                        message: 'Please Select Country',
                    },
                ]}
            >
                <Select
                    allowClear
                    showSearch
                    onChange={handleCountryChange}
                    options={countryList?.map((country) => ({
                        value: country.label,
                        label: country.label,
                    }))}
                    filterOption={(input, option) =>
                        option?.label
                            ?.toLowerCase()
                            .includes(input.toLowerCase()) ?? false
                    }
                    value={selectedCountry}
                />
            </Form.Item>
            <PostCodeInput
                name="buspostcode"
                label="Post Code"
                reuireMessage="Please Enter Post Code"
                placeHolder={''}
                setAddressDetails={setAddress}
            />
        </>
    )
}

const mapStateToProps = (state: any): PartneshipBussinessStateProps => {
    return {
        countryList: state.common.countryList,
        partnershipTaps: state.client.partnershipTaps,
    }
}

export default connect(mapStateToProps)(BussinessAddressForm)
